/** Web share intents that open in a new tab via `window.open`. */
export type ReferralSocialPlatform = "facebook" | "x" | "linkedin";

export type ReferralShareLinks = Record<ReferralSocialPlatform, string> & {
  /** Device composer intent; use as an `href`, never with `window.open`. */
  sms: string;
};

type Params = {
  referralLink: string;
  shareText: string;
};

/**
 * Outbound share intents for a student's referral link. Pure: callers pass the
 * resolved link and copy so this stays trivially testable.
 */
export default function buildReferralShareLinks({
  referralLink,
  shareText,
}: Params): ReferralShareLinks {
  const encodedLink = encodeURIComponent(referralLink);
  const encodedText = encodeURIComponent(shareText);
  const encodedMessage = encodeURIComponent(`${shareText} ${referralLink}`);

  return {
    // `sms:?&body=` is the one form both iOS and Android honour for a
    // prefilled message with no recipient.
    sms: `sms:?&body=${encodedMessage}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedLink}`,
    x: `https://twitter.com/intent/tweet?url=${encodedLink}&text=${encodedText}`,
    linkedin: `https://www.linkedin.com/shareArticle?mini=true&url=${encodedLink}&title=${encodedText}`,
  };
}
